import { render, staticRenderFns } from "./CreateUserBasic.vue?vue&type=template&id=58949e99&"
import script from "./CreateUserBasic.vue?vue&type=script&lang=js&"
export * from "./CreateUserBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports